var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFastBackward(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9072 9.91037V6.56986C12.9072 5.31813 11.5582 4.57151 10.5511 5.26585L2.67484 10.696C1.77505 11.3163 1.77505 12.6837 2.67484 13.304L10.5511 18.7341C11.5582 19.4285 12.9072 18.6819 12.9072 17.4301V14.0896L19.6439 18.7341C20.651 19.4285 22 18.6819 22 17.4301V6.56986C22 5.31813 20.651 4.57151 19.6439 5.26585L12.9072 9.91037Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFastBackward);
export default __webpack_public_path__ + "static/media/fast-backward.b79d89f46a044b45ce2782fb5ddbc14c.svg";
export { ForwardRef as ReactComponent };